import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FaIconLibrary, IconDefinition } from '@fortawesome/angular-fontawesome';
import { faFacebook, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';

import { FooterComponent, TitleComponent } from './core/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, TitleComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  //#region Application Properties
  title = 'Hakikat';
  //#endregion

  //#region Font Awesome Common Icons Library
  private readonly faIcons: IconDefinition[] = [
    // Social Media Icons
    faFacebook,
    faInstagram,
    faTiktok,
    faYoutube
  ];

  private readonly faLibrary: FaIconLibrary = inject(FaIconLibrary);
  //#endregion

  constructor() {
    this.faLibrary.addIcons(...this.faIcons);
  }
}
